export default "__VITE_ASSET__BJ_i_S_N__"